import { AgentThreadMessageDetail } from "@/api";

export interface AgentThreadMessageContent {
  id?: string;
  role_name: string;
  content: string;
  role_type: "user" | "assistant";
  func_name?: string;
  args?: Record<string, unknown>;
  result?: unknown;
  trigger?: "cancel" | "approve" | "auto";
  is_error?: boolean;
  chunk_idx?: number;
  auto_mode?: boolean;
  tool_call_id?: string;
  mask_output?: boolean;
  progress?: number;
  total?: number;
}

export type AgentThreadMessage = Omit<AgentThreadMessageDetail, "content"> & {
  content: AgentThreadMessageContent;
};

export interface AgentThreadAssistantIteration {
  id: string;
  messages: (AgentThreadMessage[] | AgentThreadMessage)[];
  voting?: number;
}

export type AgentThreadMessageItem =
  | AgentThreadAssistantIteration
  | AgentThreadMessage;

export function isAssistantIteration(
  message: AgentThreadMessageItem,
): message is AgentThreadAssistantIteration {
  return "messages" in message;
}
